// extracted by mini-css-extract-plugin
export default {"main":"Welcome_main__U0R8e","header":"Welcome_header__bz4X7","welcome":"Welcome_welcome__R7J-F"};